/**
 * Blog posts block: AJAX category filter, load more, skeleton loader.
 */
jQuery(function ($) {
	if (typeof window.localVars === 'undefined') {
		return;
	}

	const $blocks = $('.js-blog-posts');
	if (!$blocks.length) {
		return;
	}

	function buildSkeletonCard() {
		return (
			'<article class="blog-posts-skeleton post-box column" aria-hidden="true">' +
				'<div class="blog-posts-skeleton__image blog-posts-skeleton-shimmer"></div>' +
				'<div class="blog-posts-skeleton__body">' +
					'<span class="blog-posts-skeleton__title blog-posts-skeleton-shimmer"></span>' +
					'<span class="blog-posts-skeleton__line blog-posts-skeleton-shimmer"></span>' +
					'<span class="blog-posts-skeleton__line blog-posts-skeleton__line--short blog-posts-skeleton-shimmer"></span>' +
				'</div>' +
			'</article>'
		);
	}

	function buildSkeletonMarkup(count) {
		const cards = [];
		for (let i = 0; i < count; i++) {
			cards.push(buildSkeletonCard());
		}
		return cards.join('');
	}

	$blocks.each(function () {
		const $root = $(this);
		const $grid = $root.find('.blog-posts__grid');
		const $loadMoreWrap = $root.find('.blog-posts__load-more');
		const $loadMoreBtn = $root.find('.js-blog-posts-load-more');
		const $status = $root.find('.blog-posts__status');
		const $filters = $root.find('.js-blog-posts-filter');
		const perPage = parseInt($root.attr('data-per-page'), 10) || 6;

		let loading = false;
		let currentCategory = parseInt($root.attr('data-category'), 10) || 0;
		let currentPage = parseInt($root.attr('data-page'), 10) || 1;
		let hasMore = $root.attr('data-has-more') === '1';

		function setHasMore(value) {
			hasMore = value;
			$root.attr('data-has-more', value ? '1' : '0');
			$loadMoreWrap.toggleClass('is-hidden', !value);
		}

		function setLoadingState(isLoading) {
			$root.toggleClass('is-loading', isLoading);
			$root.attr('aria-busy', isLoading ? 'true' : 'false');
			$filters.attr('aria-disabled', isLoading ? 'true' : 'false');
			$loadMoreBtn.prop('disabled', isLoading);
		}

		function removeSkeleton() {
			$grid.find('.blog-posts-skeleton').remove();
		}

		function showSkeleton(mode) {
			removeSkeleton();
			if (mode === 'replace') {
				$grid.html(buildSkeletonMarkup(perPage));
			} else {
				$grid.append(buildSkeletonMarkup(perPage));
			}
		}

		function fetchPosts(page, categoryId, mode) {
			if (loading) {
				return;
			}

			loading = true;
			setLoadingState(true);
			$status.text('Loading');

			if (mode === 'replace') {
				showSkeleton('replace');
			} else {
				showSkeleton('append');
			}

			$.ajax({
				url: window.localVars.ajax_url,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'dma_blog_posts',
					nonce: window.localVars.nonce,
					category_id: categoryId,
					page,
					per_page: perPage,
				},
			})
				.done(function (res) {
					removeSkeleton();

					if (!res || !res.success || !res.data) {
						$status.text('');
						return;
					}

					const payload = res.data;

					if (mode === 'replace') {
						$grid.html(payload.html || '');
					} else if (payload.html) {
						$grid.append(payload.html);
					}

					currentPage = payload.page || page;
					$root.attr('data-page', currentPage);
					setHasMore(!!payload.has_more);
					$status.text('');
				})
				.fail(function () {
					removeSkeleton();
					$status.text('');
				})
				.always(function () {
					loading = false;
					setLoadingState(false);
				});
		}

		$root.on('click', '.js-blog-posts-filter', function (e) {
			e.preventDefault();

			const $link = $(this);
			const categoryId = parseInt($link.attr('data-category'), 10) || 0;

			if (loading || categoryId === currentCategory) {
				return;
			}

			currentCategory = categoryId;
			currentPage = 0;
			$root.attr('data-category', categoryId);

			$filters.removeClass('active');
			$link.addClass('active');

			fetchPosts(1, categoryId, 'replace');
		});

		$loadMoreBtn.on('click', function (e) {
			e.preventDefault();

			if (loading || !hasMore) {
				return;
			}

			fetchPosts(currentPage + 1, currentCategory, 'append');
		});
	});
});
